<template>
    <div class="container-detail">
        <div class="detail-header-buttons">
            <v-btn @click="back" style="width: auto !important" class="button-accept">
                <v-icon>mdi-chevron-left</v-icon>
                Вернуться к странице
            </v-btn>

            <v-btn @click="goToEdit" style="width: auto !important" class="button-action">
                Редактировать
            </v-btn>
        </div>

        <div class="detail-main">
            <div class="detail-main-first-container">
                <div class="first-container-box" v-if="block && block.type && blocksType.length > 0">
                    <div class="container-box-title">
                        Вид блока
                    </div>
                    <div class="container-box-text">
                        <div class="d-flex align-center">
                            <v-img max-width="50px" :src="getType(block.type, true)"></v-img>
                            <div style="margin-left: 20px"> {{ getType(block.type, false) }}</div>
                        </div>
                    </div>
                </div>
                <div class="first-container-box" v-if="block && block.title">
                    <div class="container-box-title">
                        Заголовок
                    </div>
                    <div class="container-box-text">
                        {{ block.title }}
                    </div>
                </div>
                <div class="first-container-box" v-if="block && block.originalImage">
                    <div class="container-box-title">
                        Изображение блока
                    </div>
                    <div class="container-box-text">
                        <img @click="openDialogImg(block.originalImage)" v-if="block.originalImage"
                            style=" cursor: pointer; height: 38px; object-fit: contain;" :src="block.originalImage">
                    </div>
                </div>
                <div class="first-container-box" v-if="block && block.subtitle">
                    <div class="container-box-title">
                        Подзаголовок
                    </div>
                    <div class="container-box-text">
                        {{ block.subtitle }}
                    </div>
                </div>
                <div class="first-container-box" v-if="block && block.text">
                    <div class="container-box-title">
                        Текст
                    </div>
                    <div class="container-box-text">
                        {{ block.text }}
                    </div>
                </div>
                <div class="first-container-box" v-if="block && block.color">
                    <div class="container-box-title">
                        Цвет
                    </div>
                    <div class="container-box-text d-flex align-center">
                        <div style="width: 20px; height: 20px; margin-right: 10px" :style="{ background: block.color }">
                        </div>
                        {{ block.color }}
                    </div>

                </div>
                <div class="first-container-box" v-if="block && block.transition && block.transition.type">
                    <div class="container-box-title">
                        Вид перехода
                    </div>
                    <div class="container-box-text">
                        <span v-if="block && block.transition && block.transition.type == 'page'">
                            Страница
                        </span>
                        <span v-else-if="block && block.transition && block.transition.type == 'url'">
                            Ссылка
                        </span>
                        <span v-else-if="block && block.transition && block.transition.type == 'file'">
                            Файл
                        </span>
                        <span v-else-if="block && block.transition && block.transition.type == 'deeplink'">
                            Внутренний раздел
                        </span>


                    </div>
                </div>
                <div class="first-container-box"
                    v-if="block && block.transition && block.transition.type == 'url' && block.transition.path">
                    <div class="container-box-title">
                        Ссылка
                    </div>
                    <div class="container-box-text">
                        <a target="_blank" :href="block.transition.path">{{ block.transition.path }}</a>
                    </div>
                </div>
                <div class="first-container-box"
                    v-if="block && block.transition && block.transition.type == 'file' && block.transition.path">
                    <div class="container-box-title">
                        Файл
                    </div>
                    <div class="container-box-text">
                        <a target="_blank" :href="block.transition.path">файл</a>
                    </div>
                </div>
                <div class="first-container-box"
                    v-if="block && block.transition && block.transition.type == 'page' && block.transition.page">
                    <div class="container-box-title">
                        Страница
                    </div>
                    <div class="container-box-text">
                        {{ block.transition.page.title }}
                    </div>
                </div>
                <div class="first-container-box"
                    v-if="block && block.transition && block.transition.type == 'deeplink' && block.transition.appSection">
                    <div class="container-box-title">
                        Внутренний раздел
                    </div>
                    <div class="container-box-text">
                        {{ block.transition.appSection.name }}
                    </div>
                </div>
                <div class="first-container-box" v-if="block && block.files.length > 0">
                    <div class="container-box-title">
                        Вложенный файлы
                    </div>
                    <div class="container-box-text">
                        <div v-for="(i, index) in block.files" :key="index">
                            <v-icon> mdi-file-pdf-box </v-icon>
                            <a style="margin-left:8px" target="_blank" :href="i.file">{{ i.name }}</a>
                        </div>
                    </div>
                </div>







            </div>

            <DialogImage v-model="dialogImg" :src="previewImage" />

        </div>
    </div>
</template>
<script>

export default {

    data: () => ({
        block: null,
        dialogImg: false,
        previewImage: null,

        imageWidth: 0,
        blocksType: []

    }),
    methods: {
        getType(type, src) {
            const obj = this.blocksType.filter(item => item.key == type)

            if (src) {
                return obj[0].icon
            }
            else {
                return obj[0].name
            }
        },
        openDialogImg(src) {
            this.previewImage = src
            this.dialogImg = true
        },
        back() {
            this.$router.push({ name: 'PageConstructor', params: { id: this.$route.params.id } })
        },
        goToEdit() {
            this.$router.push({ name: 'EditBlockConstructor', params: { id: this.$route.params.id, idBlock: this.$route.params.idBlock } })
        },

        getBlock() {
            this.$axios.get(this.$store.getters.apiAdminPanelV2 + '/page/block', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    blockId: this.$route.params.idBlock
                }
            })
                .then(res => {
                    this.block = res.data

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
        getTypeBlocks() {
            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/page/block/type/list', {},
                {
                    headers: {
                        'authorization': this.$store.getters.adminPanelHeaderAuth
                    }
                })
                .then(res => {

                    this.blocksType = res.data.items

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })
        },
    },
    created() {
        this.getTypeBlocks()
        this.getBlock()
    }
}
</script>
<style lang="scss" scoped>
.container-detail {
    box-sizing: border-box;
    padding: 40px !important;

    .detail-header-buttons {
        display: flex;
        justify-content: space-between;
        margin-bottom: 40px;
    }

    .detail-main {
        display: flex;
        justify-content: space-between;

        .detail-main-first-container {
            width: 48%;

            .first-container-box {

                margin-bottom: 40px;

                .container-box-title {
                    font-size: 24px;
                    font-weight: 600;

                }

                .container-box-text {
                    font-size: 18px;
                    font-weight: 400;
                    word-break: break-word;
                }

                .container-box-text-list {
                    .container-box-text-list-item {
                        display: flex;
                        margin-bottom: 5px;

                        .list-item-subtitle {
                            font-size: 16px;
                            font-weight: 600;
                            color: #929292;
                            width: 200px;
                        }

                        .list-item-text {
                            font-size: 18px;
                            font-weight: 400;
                        }

                    }
                }
            }
        }

        .detail-main-second-container {
            width: 48%;

            .table-img {
                cursor: pointer;
                height: 38px;
                object-fit: contain;
            }

            .second-container-box {
                width: 100%;
                margin-bottom: 40px;

                .container-box-title {
                    font-size: 24px;
                    font-weight: 600;

                }

                .container-box-text {
                    font-size: 18px;
                    font-weight: 400;
                    word-break: break-word;

                }

                .container-box-onlytext {
                    margin-top: 10px;
                }
            }
        }

    }
}
</style>